import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { IconLogin, IconCart, IconLogout } from "../../icons/Icons";
import "./StoreHeader.css";
import { validateClienteSession } from "../../services/authCliente";

function StoreHeader({ onSearch }) {
  const navigate = useNavigate();
  const location = useLocation();

  let cliente = null;
  const token = localStorage.getItem("cliente_token");

  try {
    cliente = JSON.parse(localStorage.getItem("cliente"));
  } catch {
    cliente = null;
  }

  const isLogged = !!token && !!cliente;

  const handleLoginClick = () => {
    if (isLogged) navigate("/store/account");
    else navigate("/store/login", { state: { mode: "login" } });
  };

  const handleLogout = () => {
    localStorage.removeItem("cliente_token");
    localStorage.removeItem("cliente");
    navigate("/store", { replace: true });
  };

  useEffect(() => {
    if (!isLogged) return;

    let cancelled = false;

    (async () => {
      const r = await validateClienteSession();
      if (cancelled) return;

      if (!r?.ok) {
        localStorage.removeItem("cliente_token");
        localStorage.removeItem("cliente");

        navigate("/store/login", {
          replace: true,
          state: {
            mode: "login",
            reason: r?.reason || "expired_or_invalid",
            message: "Tu sesión expiró o no es válida. Inicia sesión de nuevo.",
          },
        });
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [location.pathname]);

  return (
    <header className="adc-header">
      <div className="adc-header-inner">
        <div className="adc-header-left" onClick={() => navigate("/store")}>
          <img src="/image/ADC-Logo.png" className="adc-logo" alt="ADC" />
          <h1 className="adc-brand">Aircraft Service & Part</h1>
        </div>

        <div className="adc-header-search">
          <input
            className="adc-search-input"
            placeholder="Search aircraft parts or product name"
            onChange={(e) => onSearch?.(e.target.value)}
          />
        </div>

        <div className="adc-header-actions">
          <button className="adc-btn" onClick={handleLoginClick}>
            {IconLogin}
            <span>{isLogged ? "My account" : "Login"}</span>
          </button>

          {isLogged && (
            <button className="adc-btn adc-btn-logout" onClick={handleLogout}>
              {IconLogout}
              <span>Logout</span>
            </button>
          )}

          <button className="adc-btn" onClick={() => navigate("/store/cart")}>
            {IconCart}
            <span>Cart</span>
          </button>
        </div>
      </div>
    </header>
  );
}

export default StoreHeader;
